import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

/// Manage our api authentication and any other global api changes here

export namespace SiteApi {
  const BaseHeaders = {
    "Ocp-Apim-Subscription-Key": (window as any).currentEnvironment
      .REACT_APP_API_GATEWAY_AUTHORIZATION_KEY,
    "Optimizely-Authorization": (window as any).currentEnvironment
      .REACT_APP_OPTIMIZELY_AUTHORIZATION_KEY,
  };

  const UpdateConfig = (config?: AxiosRequestConfig) => {
    if (!config) {
      config = {
        headers: BaseHeaders,
      };
    } else {
      config = {
        ...config,
        headers: {
          ...config.headers,
          ...BaseHeaders,
        },
      };
    }

    return config;
  };

  export const Get = <T>(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<T>> => axios.get<T>(url, UpdateConfig(config));

  export const Post = <T>(
    url: string,
    data: any,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<T>> =>
    axios.post<T>(url, data, UpdateConfig(config));
}
